import React, { useState } from 'react';
import { Alert, Button, Card, CardBody, CardHeader, Col, Collapse, Row, Spinner } from 'reactstrap';
import { useExecutionInfo } from '../hooks/useExecutionInfo';
import { useStoreActions } from '../stores/store'

const NERSection: React.FC<{ id: string }> = ({ id }) => {
  const { data, isLoading, isError } = useExecutionInfo(id)
  const updateSearchTerm = useStoreActions(s => s.updateSearchTerm)

  const [collapsed, setCollapsed] = useState(true)

  const handleSearch = (t: string) => {
    updateSearchTerm(t)
    const elem = document.querySelector('#subt_search')
    if (elem) elem.scrollIntoView()
  }

  let content: JSX.Element | null = null

  if (isLoading) {
    content = <Spinner />
  } else if (isError) {
    content = (
      <Alert color="danger">
        Something went wrong!
      </Alert>
    )
  } else if (!data || !data.entities || Object.values(data.entities).length === 0) {
    content = (
      <Alert color="warning">
        No entities!
      </Alert>
    )
  } else {
    content = (
      <>
        {data.entities.date && data.entities.date.length > 0 &&
          <>
            <h4 className='mb-3'>Dates</h4>
            {data.entities.date.map((p, i) => (
              <Button className="mr-2 mb-2" size="sm" key={i} color="primary" onClick={() => {
                handleSearch(p[0])
              }}>
                {p[0]}
              </Button>
            ))}
            <hr />
          </>
        }
        {data.entities.gpe && data.entities.gpe.length > 0 &&
          <>
            <h4 className='mb-3'>Geographic Locations</h4>
            {data.entities.gpe.map((p, i) => (
              <Button className="mr-2 mb-2" size="sm" key={i} color="primary" onClick={() => {
                handleSearch(p[0])
              }}>
                {p[0]}
              </Button>
            ))}
            <hr />
          </>
        }
        {data.entities.money && data.entities.money.length > 0 &&
          <>
            <h4 className='mb-3'>Monetary values</h4>
            {data.entities.money.map((p, i) => (
              <Button className="mr-2 mb-2" size="sm" key={i} color="primary" onClick={() => {
                handleSearch(p[0])
              }}>
                {p[0]}
              </Button>
            ))}
            <hr />
          </>
        }
        {data.entities.org && data.entities.org.length > 0 &&
          <>
            <h4 className='mb-3'>Organization</h4>
            {data.entities.org.map((p, i) => (
              <Button className="mr-2 mb-2" size="sm" key={i} color="primary" onClick={() => {
                handleSearch(p[0])
              }}>
                {p[0]}
              </Button>
            ))}
            <hr />
          </>
        }
        {data.entities.person && data.entities.person.length > 0 &&
          <>
            <h4 className='mb-3'>People</h4>
            {data.entities.person.map((p, i) => (
              <Button className="mr-2 mb-2" size="sm" key={i} color="primary" onClick={() => {
                handleSearch(p[0])
              }}>
                {p[0]}
              </Button>
            ))}
            <hr />
          </>
        }
      </>
    )
  }


  return (
    <>
      <Row>
        <Col className="order-xl-1">
          <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
              <Row className="align-items-center">
                <Col sm="8">
                  <h3 className="mb-0">Entities</h3>
                </Col>
                <Col className="text-right" xs="4">
                  <Button
                    size="sm"
                    color="primary"
                    onClick={() => {
                      setCollapsed(!collapsed)
                    }}
                  >
                    {collapsed ? 'Expand' : 'Collapse'}
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <Collapse isOpen={!collapsed}>
              <CardBody>
                {content}
              </CardBody>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <br />
    </>
  );
}

export default NERSection
